import { Table, Pagination, Row, Col } from "antd";
import React, { Fragment } from "react";
import { FormattedMessage } from 'react-intl';

import { Loading } from '~/components';


class CTMVoucherResult extends React.Component {
    constructor(props) {
        super(props);
    };

    render() {
        const { dataSource, count, searchParam, handleSubmit, handleSearchParamChange, handleDownload, searchLoading, handleDownloadInv, downloadVoucherNo } = this.props;
        const rowSelection = dataSource && dataSource.length > 0 ? {
            selectedRowKeys: downloadVoucherNo,
            onSelectAll: (selected, selectedRows, changeRows) => {
                let list = downloadVoucherNo;
                let elements = changeRows.map(x => x.VoucherNo);
                if (selected) {
                    elements.forEach(element => {
                        if (list.length == 0 || !list.find(x => x == element)) {
                            list.push(element);
                        }
                    });
                } else {
                    elements.forEach(element => {
                        if (list.length == 0 || list.find(x => x == element)) {
                            list = list.filter(x => x !== element);
                        }
                    });
                }
                handleDownloadInv(list)
            },
            onSelect: (record, selected, selectedRows, nativeEvent) => {
                let list = downloadVoucherNo
                let element = record.VoucherNo;
                if (selected) {
                    if (list.length == 0 || !list.find(x => x == element)) {
                        list.push(element);
                    }
                } else {
                    if (list.length == 0 || list.find(x => x == element)) {
                        list = list.filter(x => x !== element);
                    }
                }
                handleDownloadInv(list)
            },

        } : undefined;
        const show = (val) => {
            if (val > 0) {
                return <span style={{ 'font-weight': ' bold', 'cursor': 'pointer' }}> ...</span>
            };
        };
        const otherTravelDiv = (val, record, idName) => {
            if (val && val.length > 0) {
                return <div id={record.key + '_' + idName + '_div'} className="table_otherName">
                    {val.map((val, key) => {
                        return <div key={key}>
                            <span>{val}</span>
                        </div>
                    })}
                </div>
            }
        };
        const columns = [
            {
                title: <FormattedMessage id='travelerName' />,
                dataIndex: 'TravellerName',
                key: 'TravellerName',
                width: '20%',
                onCellClick: (Range) => {
                    const el = document.getElementById(Range.key + '_travelerName' + '_div');
                    if (el) {
                        el.className = el.className === "table_otherName" ? "table_otherNameActive" : "table_otherName";
                    }
                },
                render: (text, record, index) => {
                    let firstName = text[0];
                    let otherName = text.slice(1);
                    return <div >
                        <div>
                            {firstName}
                            {show(otherName.length)}
                            {otherTravelDiv(otherName, record, 'travelerName')}
                        </div>
                    </div>
                }
            },
            {
                title: <FormattedMessage id='booking_reference' />,
                dataIndex: 'BookingReference',
                key: 'BookingReference',
                onCellClick: (Range) => {
                    const el = document.getElementById(Range.key + '_booking_reference' + '_div');
                    if (el) {
                        el.className = el.className === "table_otherName" ? "table_otherNameActive" : "table_otherName";
                    }
                },
                render: (text, record, index) => {
                    let firstName = text[0];
                    let otherName = text.slice(1);

                    return <div >
                        <div>
                            {firstName}
                            {show(otherName.length)}
                            {otherTravelDiv(otherName, record, 'booking_reference')}
                        </div>
                    </div>
                }
            },
            {
                title: <FormattedMessage id='daparture_date' />,
                dataIndex: 'DepartureDate',
                key: 'DepartureDate',
            },
            {
                title: <FormattedMessage id='arrival_Date' />,
                dataIndex: 'ArrivalDate',
                key: 'ArrivalDate',
            },
            {
                title: <FormattedMessage id='voucher' />,
                dataIndex: 'VoucherNo',
                key: 'VoucherNo',
            },
            {
                title: <FormattedMessage id='transactio_date' />,
                dataIndex: 'VoucherDate',
                key: 'VoucherDate',
            },
            {
                title: <FormattedMessage id='voucher_amount' />,
                dataIndex: 'VoucherAmount',
                key: 'VoucherAmount',
            },
            {
                title: <FormattedMessage id='download_pdf' />,
                dataIndex: 'd',
                key: 'd',
                width: '8%',
                onCellClick: (range) => {
                    handleDownload(range)
                },
                render: (text, record, index) => {
                    if (typeof record.pkey === 'undefined') {
                        if (downloadVoucherNo) {
                            if (downloadVoucherNo.length == 0 || downloadVoucherNo.find(x => x == record.VoucherNo)) {
                                return <div><a ><i className='download-icon'> </i></a></div>
                            } else {
                                return <div className='download-notIcon'></div>
                            }
                        }
                    }

                }

            }
        ];
        return (
            <Fragment>
                {searchLoading && <Loading />}
                <Table dataSource={dataSource}
                    columns={columns}
                    className='fare-forecaster-form test invTable'
                    pagination={false}
                    scroll={{ y: 300 }}
                    indentSize={0}
                    rowKey={(x, index) => `${x.VoucherNo}_${index}`}
                    rowSelection={rowSelection}
                    hideDefaultSelections={false}
                >

                </Table>
                <br />
                <Row >
                    <Col className="Pagination" >
                        {
                            count > 0 ? <Pagination total={count} current={searchParam.pageIndex} pageSize={searchParam.pageSize} onChange={(page) => {
                                searchParam.pageIndex = page;
                                handleSearchParamChange(searchParam);
                                handleSubmit(null, null, page);
                            }}
                                showTotal={(count, range) => `${range[0]} -${range[1]} of ${count} `}></Pagination> : null}
                    </Col>
                </Row>
            </Fragment>
        )
    }
}

export default CTMVoucherResult;
